import useReturnsTable from "./useReturnsTable";
import secondaryComponents from "..";
import ReturnDetails from "../ReturnDetails";

const ReturnsTable = ({ returns, metaDetails, gotoPage = () => {} }) => {
  const { instance, selectedOrder, setSelectedOrder } = useReturnsTable({
    returns,
  });
  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      <secondaryComponents.TableHelper
        getTableBodyProps={getTableBodyProps}
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
      >
        <h4 className="pt-5 text-center">No Data Available</h4>
      </secondaryComponents.TableHelper>

      {/* pagination */}
      {returns?.length > 0 && (
        <div className="mt-auto">
          <secondaryComponents.Pagination
            totalPageNumber={metaDetails?.last_page}
            handlePageClick={(value) => gotoPage(value?.selected + 1)}
            currentPage={metaDetails?.current_page}
          />
        </div>
      )}

      <secondaryComponents.SideModal
        isActive={selectedOrder !== null}
        closeModal={() => setSelectedOrder(null)}
        width={1100}
      >
        <ReturnDetails
          closeModal={() => setSelectedOrder(null)}
          orderId={selectedOrder}
          defaultLanding={"tnxReceipt"}
          viaSaleRecord={true}
        />
      </secondaryComponents.SideModal>
    </>
  );
};

export default ReturnsTable;
